import React from 'react'
import { IconButton, IconButtonProps } from '@mui/material'
import { J1RightarrowD } from '@e3dc-react/icons'

/**
 * This component is a button with right arrow icon
 * typically used for navigation purposes.
 */
const NavigationButton: React.FC<IconButtonProps> = props => {
  return (
    <IconButton {...props}>
      <J1RightarrowD sx={{ width: '24px', height: '24px', color: 'grey.grey00' }} />
    </IconButton>
  )
}

export default NavigationButton
